
// https://stackoverflow.com/questions/3177836/how-to-format-time-since-xxx-e-g-4-minutes-ago-similar-to-stack-exchange-site
const timeSince = (date: Date) => {
    const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    let interval = seconds / 31536000;

    if (interval > 1) {
        return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
};

const mapIsoToHuman = (element: Element) => {
    const isoDate = element.getAttribute("date");
    if (!isoDate) {
        return;
    }
    const date = new Date(isoDate);
    element.innerHTML = timeSince(date) + " ago";
}

document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('[date]')
        .forEach(mapIsoToHuman);
});
